/* ====================================================================
   FLOOREVER — FICHE PRODUIT « LE SUD » (sections/floorever-produit.liquid)
   Vanilla JS, chargé en defer, aucune dépendance.

   Racine : [data-pdp] avec, en data-attributes :
   - data-prix-colis-cents   prix TTC d'un colis, en centimes
   - data-m2-colis           m² couverts par un colis (absent => mode Colis seul)
   - data-variant-echantillon id de la variante échantillon à 0 € (optionnel)
   - data-est-sol            "true" si produit sol (minimum appliqué)
   - data-min-colis          minimum de commande en colis (0 = désactivé)
   - data-max-echantillons   limite douce d'échantillons par panier
   - data-route-cart-add / data-route-cart  routes Shopify (sans .js)

   Modules : galerie (carrousel scroll-snap + zoom <dialog> navigable —
   NE PAS TOUCHER, sauf les deux retouches de la recette du 18/10/2026 :
   vignette active cadrée dans sa bande sans faire défiler la page,
   ticket 48 ; slides 2 et suivantes chargées à la première interaction,
   ticket 47), achat fusionné (3 modes de saisie pilotant l'unique
   quantité du form panier + garde-fou minimum), échantillon gratuit
   (fetch /cart/add.js avec limite via /cart.js, un seul par décor).

   Règles métier (DS §5.5 + benchmark Saint-Maclou) :
   - besoin = m² × (1 + marge) ; marge = 0,10 (pose droite, défaut),
     0,15 (pose en diagonale) ou 0 (sans marge)
   - nb = Math.ceil(besoin / m²ParColis) — toujours au colis supérieur
   - total = nb × prixColis ; formats Intl.NumberFormat('fr-FR')
   - virgule française acceptée à la saisie (surface, longueur, largeur)
   - sols : sous data-min-colis (saisie vide ou 0 comprise), CTA
     désactivé + note calme + bouton échantillon mis en avant
     (.is-highlight) ; la quantité initiale vaut le minimum => aucune
     note à l'arrivée
   - sans metafield m2_par_colis : segments non rendus, saisie directe
     en colis, résultat sans m²

   TESTS MANUELS (fiche sol, m2_par_colis = 2,64, minimum 5, prix 63,10) :
   1. Arrivée : mode Surface actif, quantité 5, résultat « 5 colis ·
      13,20 m² couverts · 315,50 € », CTA « Ajouter au panier — 315,50 € »,
      aucune note minimum visible.
   2. Surface « 10 » (+10 %) -> 5 colis -> CTA désactivé, note sable calme,
      échantillon mis en avant ; « 12 » -> 5 colis -> CTA réactivé + total.
   3. Marge « Sans marge » / « Pose en diagonale +15 % » : résultat suit.
   4. Mode L×L : « 4 » × « 3,2 » (virgule acceptée) = 12,8 m² -> 6 colis.
   5. Mode Colis : « 2 » -> note + CTA désactivé ; « 6 » -> CTA + total ;
      champ vidé -> CTA désactivé (jamais de soumission vide sur un sol).
      La quantité soumise au panier suit chaque mode (un seul input
      name="quantity").
   6. Produit sans m2_par_colis : pas de segments, résultat sans m².
   7. Clavier : flèches dans le radiogroup (roving tabindex),
      focus-visible partout.
   8. Sans JS : champ quantité visible (5 colis) + CTA fonctionnels.
   9. Échantillon : ajout AJAX, limite 3, événement floorever:cart:change ;
      galerie strictement inchangée (balayage, zoom, vignettes).
   10. Un échantillon par décor : avec FECH55308-ECH au panier, la fiche
      FE308 d'une autre gamme affiche « Déjà dans le panier », désactivé ;
      double clic sur une fiche dont le décor n'est pas au panier : un
      seul échantillon, quantité 1, puis « Déjà dans le panier ».

   Événement émis après ajout d'échantillon :
   document -> 'floorever:cart:change' (detail.cart = payload /cart.js)
   ==================================================================== */
(function () {
  'use strict';

  var NBSP = '\u00A0';
  var fmtEur = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  var fmtM2 = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  /* Saisie française : « 12,5 », « 12.5 », espaces (fines) insécables. */
  function parseDecimal(raw) {
    if (raw == null) return NaN;
    var s = String(raw).trim().replace(/[\s\u00A0\u202F]/g, '').replace(',', '.');
    if (s === '') return NaN;
    return parseFloat(s);
  }

  /* ------------------------------------------------------------------
     Galerie : carrousel scroll-snap natif.
     Le balayage tactile est géré par le navigateur (scroll-snap) ; le JS
     ne fait que synchroniser l'état : compteur, vignettes, flèches
     (désactivées aux extrémités), clavier, et le zoom <dialog> navigable
     en boucle (flèches, clavier, balayage), avec préchargement des
     voisines. Respecte prefers-reduced-motion.
     ------------------------------------------------------------------ */
  function initGalerie(root) {
    var track = root.querySelector('[data-pdp-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-pdp-slide]'));
    if (!slides.length) return;

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var bandeVignettes = root.querySelector('[data-pdp-thumbs]');
    var prev = root.querySelector('[data-pdp-prev]');
    var next = root.querySelector('[data-pdp-next]');
    var compteur = root.querySelector('[data-pdp-counter]');
    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var courant = -1;

    /* Slides 2 et suivantes : images rendues en data-src / data-srcset,
       chargées à la première interaction avec la galerie, pour laisser la
       bande passante à la 1re photo, candidate au LCP mobile (ticket 47 de
       la recette). Sans JS, le <noscript> de chaque slide prend le relais. */
    var galerie = track.closest('.pdp-gallery') || track;
    var differees = Array.prototype.slice.call(track.querySelectorAll('img[data-src]'));
    var declencheurs = ['pointerenter', 'pointerdown', 'touchstart', 'focusin'];
    function chargerDifferees() {
      if (!differees.length) return;
      differees.forEach(function (im) {
        if (im.dataset.srcset) im.srcset = im.dataset.srcset;
        im.src = im.dataset.src;
        im.removeAttribute('data-srcset');
        im.removeAttribute('data-src');
      });
      differees = [];
      declencheurs.forEach(function (type) {
        galerie.removeEventListener(type, chargerDifferees);
      });
      track.removeEventListener('scroll', chargerDifferees);
    }
    if (differees.length) {
      declencheurs.forEach(function (type) {
        galerie.addEventListener(type, chargerDifferees, { passive: true });
      });
      track.addEventListener('scroll', chargerDifferees, { passive: true });
    }

    function allerA(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      chargerDifferees();
      marquer(i); /* retour immédiat (compteur, vignettes), sans attendre le scroll */
      track.scrollTo({
        left: slides[i].offsetLeft,
        behavior: instant || reduit ? 'auto' : 'smooth'
      });
    }

    /* Vignette active ramenée dans la bande en ne faisant défiler QUE la
       bande, jamais la page : scrollIntoView faisait défiler la page de
       118 px à l'ouverture de la fiche et envoyait le 1er Tab hors écran
       (ticket 48 de la recette). */
    function cadrerVignette(b, i) {
      if (!bandeVignettes || bandeVignettes.scrollWidth <= bandeVignettes.clientWidth + 1) return;
      var rBande = bandeVignettes.getBoundingClientRect();
      var rVignette = b.getBoundingClientRect();
      var cible = null;
      if (i === 0) cible = 0;
      else if (rVignette.left < rBande.left) cible = bandeVignettes.scrollLeft + rVignette.left - rBande.left;
      else if (rVignette.right > rBande.right) cible = bandeVignettes.scrollLeft + rVignette.right - rBande.right;
      if (cible === null || Math.abs(cible - bandeVignettes.scrollLeft) < 1) return;
      bandeVignettes.scrollTo({ left: cible, behavior: reduit ? 'auto' : 'smooth' });
    }

    function marquer(i) {
      if (i === courant || i < 0 || i >= slides.length) return;
      var initial = courant === -1;
      courant = i;
      if (compteur) compteur.textContent = i + 1 + '/' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      thumbs.forEach(function (b, j) {
        var actif = j === i;
        b.classList.toggle('is-active', actif);
        if (actif) {
          b.setAttribute('aria-current', 'true');
          /* À l'initialisation, rien ne défile : la 1re vignette est déjà en place. */
          if (!initial) cadrerVignette(b, j);
        } else {
          b.removeAttribute('aria-current');
        }
      });
    }
    marquer(0);

    /* Position courante : calcul direct au scroll (débounce court).
       Les slides font exactement la largeur du track, le calcul est exact.
       Plus robuste qu'un IntersectionObserver (suspendu quand la page
       n'est pas peinte) et couvre le balayage tactile natif. */
    function synchroniser() {
      marquer(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
    }
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(synchroniser, 110);
    }, { passive: true });
    /* scrollend : synchro immédiate sans timer (navigateurs récents). */
    track.addEventListener('scrollend', synchroniser, { passive: true });

    if (prev) prev.addEventListener('click', function () { allerA(courant - 1); });
    if (next) next.addEventListener('click', function () { allerA(courant + 1); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); allerA(courant - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); allerA(courant + 1); }
    });

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        allerA(parseInt(btn.dataset.index, 10) || 0);
      });
    });

    /* ---------------- Zoom <dialog> navigable, en boucle ---------------- */
    var dialog = root.querySelector('[data-pdp-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var img = dialog.querySelector('[data-pdp-dialog-img]');
    var dCompteur = dialog.querySelector('[data-pdp-dialog-counter]');
    var dPrev = dialog.querySelector('[data-pdp-dialog-prev]');
    var dNext = dialog.querySelector('[data-pdp-dialog-next]');
    var fermer = dialog.querySelector('[data-pdp-dialog-close]');
    var zIndex = 0;
    var aGlisse = false;

    function donnees(i) {
      var im = slides[i] && slides[i].querySelector('img');
      if (!im) return null;
      return { src: im.getAttribute('data-zoom-src') || im.currentSrc || im.src, alt: im.alt || '' };
    }

    function precharger(i) {
      var d = donnees((i + slides.length) % slides.length);
      if (d) new Image().src = d.src;
    }

    function montrer(i) {
      zIndex = (i + slides.length) % slides.length; /* boucle */
      var d = donnees(zIndex);
      if (d && img) { img.src = d.src; img.alt = d.alt; }
      if (dCompteur) dCompteur.textContent = zIndex + 1 + '/' + slides.length;
      if (slides.length > 1) { precharger(zIndex + 1); precharger(zIndex - 1); }
    }

    root.querySelectorAll('[data-pdp-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        montrer(parseInt(btn.dataset.index, 10) || 0);
        dialog.showModal();
      });
    });

    if (dPrev) dPrev.addEventListener('click', function () { montrer(zIndex - 1); });
    if (dNext) dNext.addEventListener('click', function () { montrer(zIndex + 1); });

    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); montrer(zIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); montrer(zIndex + 1); }
    });

    /* Balayage tactile dans le zoom (et garde anti-fermeture après glissé). */
    var x0 = null;
    dialog.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    dialog.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40 && slides.length > 1) {
        aGlisse = true;
        montrer(zIndex + (dx < 0 ? 1 : -1));
      }
    });

    if (fermer) fermer.addEventListener('click', function () { dialog.close(); });

    /* Clic sur le fond (la cible est alors le <dialog> lui-même). */
    dialog.addEventListener('click', function (e) {
      if (aGlisse) { aGlisse = false; return; }
      if (e.target === dialog) dialog.close();
    });

    /* À la fermeture, la galerie se cale sur la photo vue en zoom. */
    dialog.addEventListener('close', function () { allerA(zIndex, true); });
  }

  /* ------------------------------------------------------------------
     Achat fusionné : « De combien avez-vous besoin ? »
     Remplace les anciens modules calculateur + quantité (initCalculateur
     + initQuantite). Trois modes segmentés (Surface / Longueur × Largeur
     / Colis) pilotent LE MÊME input quantité du form panier
     ([data-achat-qty], name="quantity") : la quantité soumise est
     toujours synchronisée. Sous le minimum sols : CTA désactivé, note
     calme, bouton échantillon mis en avant — jamais de rouge anxiogène.
     ------------------------------------------------------------------ */
  function initAchat(root, prixColis, m2Colis, estSol, minColis) {
    var calc = root.querySelector('[data-achat]');
    var qty = root.querySelector('[data-achat-qty]');
    if (!calc || !qty) return;

    var modesWrap = calc.querySelector('[data-achat-modes]');
    var modeBtns = Array.prototype.slice.call(calc.querySelectorAll('[data-achat-mode]'));
    var panneaux = Array.prototype.slice.call(calc.querySelectorAll('[data-achat-panel]'));
    var surface = calc.querySelector('[data-achat-surface]');
    var longueur = calc.querySelector('[data-achat-longueur]');
    var largeur = calc.querySelector('[data-achat-largeur]');
    /* Plinthes : longueur à couvrir en mètres, longueur d'une pièce. */
    var metres = calc.querySelector('[data-achat-metres]');
    var mPiece = parseFloat(root.dataset.mPiece) || 0;
    var margeWrap = calc.querySelector('[data-achat-marge-wrap]');
    var marge = calc.querySelector('[data-achat-marge]');
    var resultat = calc.querySelector('[data-achat-result]');
    var minNote = root.querySelector('[data-achat-min-note]');
    var submit = root.querySelector('[data-pdp-submit]');
    var label = root.querySelector('[data-pdp-submit-label]');
    var labelBase = label ? (label.dataset.labelBase || label.textContent) : '';
    /* Libellés disponible / épuisé : un changement de décor peut passer de
       l'un à l'autre (produits à plusieurs variantes payantes). */
    var labelDispo = label ? (label.dataset.labelDispo || labelBase) : '';
    var labelIndispo = label ? (label.dataset.labelIndispo || labelBase) : '';
    var sample = root.querySelector('[data-pdp-sample]');
    var form = root.querySelector('.pdp-form');
    var disponible = submit ? !submit.disabled : false;
    var mode = 'colis';

    function lireColis() {
      var n = parseInt(qty.value, 10);
      return isNaN(n) || n < 1 ? 0 : n;
    }

    /* Saisie vide ou 0 comprise : sinon un champ vidé serait soumis
       quantity="" et Shopify ajouterait 1 colis sous le minimum. */
    function sousMinimum(n) {
      return estSol && minColis > 0 && n < minColis;
    }

    var uniteS = root.dataset.uniteSing || 'colis';
    var uniteP = root.dataset.unitePlur || uniteS;

    /* Résultat live « X colis · Y m² couverts · Z € » + état CTA/note. */
    function rendre() {
      var n = lireColis();
      var bloque = sousMinimum(n);

      if (resultat) {
        if (n > 0) {
          /* Unité de vente : colis, rouleau (sous-couche), plinthe. */
          var unite = n > 1 ? uniteP : uniteS;
          var html = '<b>' + n + NBSP + unite + '</b>';
          if (m2Colis > 0) {
            html += ' · ' + fmtM2.format(n * m2Colis) + NBSP + 'm²' + NBSP + 'couverts';
          } else if (mPiece > 0) {
            html += ' · ' + fmtM2.format(n * mPiece) + NBSP + 'm';
          }
          if (prixColis > 0) {
            html += ' · <b class="cr-total">' + fmtEur.format(n * prixColis) + '</b>';
          }
          resultat.innerHTML = html;
          resultat.classList.add('is-on');
        } else {
          resultat.innerHTML = '';
          resultat.classList.remove('is-on');
        }
      }

      if (minNote) minNote.hidden = !bloque;
      if (sample) sample.classList.toggle('is-highlight', bloque);
      if (submit) submit.disabled = !disponible || bloque;
      if (label) {
        if (!disponible) {
          label.textContent = labelIndispo;
        } else if (prixColis > 0) {
          /* Montant dans son propre span : chiffres en Schibsted, jamais en
             Helmet (.btn .btn-prix, design system v2). */
          label.textContent = labelDispo;
          if (n > 0 && !bloque) {
            var prixSpan = document.createElement('span');
            prixSpan.className = 'btn-prix';
            prixSpan.textContent = ' — ' + fmtEur.format(n * prixColis);
            label.appendChild(prixSpan);
          }
        }
      }
    }

    /* Conversion m² -> colis. Une saisie vide ou invalide ne touche pas
       la quantité courante (pas d'état « 0 colis » anxiogène). */
    function calculer() {
      if (m2Colis > 0) {
        var m2 = NaN;
        if (mode === 'surface' && surface) {
          m2 = parseDecimal(surface.value);
        } else if (mode === 'lxl' && longueur && largeur) {
          var lon = parseDecimal(longueur.value);
          var lar = parseDecimal(largeur.value);
          if (lon > 0 && lar > 0) m2 = lon * lar;
        }
        if (m2 > 0) {
          var taux = marge ? parseFloat(marge.value) || 0 : 0;
          /* Arrondi au millionième AVANT le ceil : 26,4 / 1,76 vaut
             15,000000000000002 en flottant et donnait 16 colis. */
          qty.value = Math.ceil(Math.round((m2 * (1 + taux)) / m2Colis * 1e6) / 1e6);
        }
      } else if (mPiece > 0 && mode === 'metres' && metres) {
        /* Mètres -> plinthes, arrondi au-dessus (même garde flottante). */
        var lm = parseDecimal(metres.value);
        if (lm > 0) qty.value = Math.ceil(Math.round(lm / mPiece * 1e6) / 1e6);
      }
      rendre();
    }

    function setMode(m, focaliser) {
      mode = m;
      modeBtns.forEach(function (b) {
        var actif = b.dataset.achatMode === m;
        b.setAttribute('aria-checked', actif ? 'true' : 'false');
        b.tabIndex = actif ? 0 : -1;
        if (actif && focaliser) b.focus();
      });
      panneaux.forEach(function (p) {
        p.hidden = p.dataset.achatPanel !== m;
      });
      if (margeWrap) margeWrap.hidden = m === 'colis';
      calculer();
    }

    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.dataset.achatMode); });
    });

    /* Radiogroup clavier : flèches = changer de mode (roving tabindex). */
    if (modesWrap) {
      modesWrap.addEventListener('keydown', function (e) {
        var dir = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
        else return;
        e.preventDefault();
        var i = 0;
        modeBtns.forEach(function (b, j) {
          if (b.dataset.achatMode === mode) i = j;
        });
        var suivant = modeBtns[(i + dir + modeBtns.length) % modeBtns.length];
        setMode(suivant.dataset.achatMode, true);
      });
    }

    if (surface) surface.addEventListener('input', calculer);
    if (longueur) longueur.addEventListener('input', calculer);
    if (largeur) largeur.addEventListener('input', calculer);
    if (metres) metres.addEventListener('input', calculer);
    if (marge) marge.addEventListener('change', calculer);
    qty.addEventListener('input', rendre);

    /* Ceinture + bretelles : pas de submit sous le minimum (CTA déjà off). */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (sousMinimum(lireColis())) e.preventDefault();
      });
    }

    /* État d'arrivée : segments dévoilés + mode Surface par défaut quand
       le metafield m2_par_colis existe ; sinon saisie directe en colis.
       La quantité initiale (minimum sols / 1) vient du rendu Liquid :
       aucun avertissement à l'arrivée, résultat et total déjà affichés. */
    if (m2Colis > 0 && modesWrap) {
      modesWrap.hidden = false;
      setMode('surface');
    } else if (mPiece > 0 && modesWrap) {
      modesWrap.hidden = false;
      setMode('metres');
    } else {
      rendre();
    }

    /* Changement de décor : nouveau prix et nouvelle disponibilité. */
    return {
      majVariante: function (prix, dispo) {
        prixColis = prix;
        disponible = !!dispo;
        rendre();
      }
    };
  }

  /* ------------------------------------------------------------------
     Sélecteur de décor (produits à plusieurs variantes payantes, plinthes
     et profilés assortis) : radios natifs name="id" du formulaire. Au
     changement : prix rendu en Liquid échangé depuis son <template>, nom
     du décor, réf. décor et SKU, badge de stock, bouton, image de la
     variante si elle en a une, ?variant= dans l'URL sans entrée
     d'historique, annonce role="status". Les sols n'ont pas de sélecteur.
     ------------------------------------------------------------------ */
  function initDecors(root, achat) {
    var champ = root.querySelector('[data-pdp-decors]');
    if (!champ) return;
    /* Liste déroulante depuis le 17/10/2026 ; les radios restent gérés en repli. */
    var select = champ.querySelector('[data-pdp-decor-select]');
    var radios = Array.prototype.slice.call(champ.querySelectorAll('[data-pdp-decor]'));
    function choisi() {
      if (select) return select.options[select.selectedIndex] || null;
      return champ.querySelector('[data-pdp-decor]:checked');
    }
    var nom = root.querySelector('[data-pdp-decor-nom]');
    var annonce = root.querySelector('[data-pdp-decor-annonce]');
    var zonePrix = root.querySelector('[data-pdp-prix]');
    var sku = root.querySelector('[data-pdp-sku]');
    var refDecor = root.querySelector('[data-pdp-decor-ref]');
    var stock = root.querySelector('[data-pdp-stock]');
    var stockLabel = root.querySelector('[data-pdp-stock-label]');

    function appliquer(r, parUtilisateur) {
      var d = r.dataset;
      var dispo = d.dispo === 'true';
      root.dataset.prixColisCents = d.prix;
      if (nom) nom.textContent = d.titre;
      if (sku) sku.textContent = d.sku;
      if (refDecor && d.decor && d.decor !== 'FE') refDecor.textContent = d.decor;
      var tpl = root.querySelector('template[data-pdp-prix-variante="' + r.value + '"]');
      if (zonePrix && tpl) {
        zonePrix.textContent = '';
        zonePrix.appendChild(tpl.content.cloneNode(true));
      }
      if (stock) {
        stock.classList.toggle('pdp-stock--ok', dispo);
        stock.classList.toggle('pdp-stock--off', !dispo);
        if (stockLabel) stockLabel.textContent = dispo ? stock.dataset.labelOk : stock.dataset.labelOff;
      }
      if (achat) achat.majVariante((parseInt(d.prix, 10) || 0) / 100, dispo);
      if (!parUtilisateur) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', r.value);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) { /* navigateur ancien : l'URL reste celle d'arrivée */ }
      if (annonce) {
        var prixTxt = zonePrix ? zonePrix.textContent.replace(/\s+/g, ' ').trim() : '';
        annonce.textContent = d.titre + ', ' + prixTxt + (dispo ? '' : ', ' + (stock ? stock.dataset.labelOff : ''));
      }
    }

    if (select) {
      select.addEventListener('change', function () {
        var o = choisi();
        if (o) appliquer(o, true);
      });
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked) appliquer(r, true);
      });
    });

    /* Retour arrière (bfcache) : le navigateur peut restaurer un autre
       décor coché que celui du rendu serveur. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var c = choisi();
      if (c) appliquer(c, false);
    });
    var coche = choisi();
    if (coche) appliquer(coche, false);
  }

  /* ------------------------------------------------------------------
     Échantillon gratuit : ajout AJAX de la variante à 0 €, avec limite
     douce (somme des lignes gratuites du panier via /cart.js) et un seul
     échantillon par décor, ticket 3 de la recette. Le décor est reconnu
     par sa réf. FExxx, data-ref, sinon lue dans data-sku, quelle que soit
     la gamme de l'échantillon au panier ; repli sur l'id de variante.
     Décor au panier : « Déjà dans le panier », bouton désactivé
     (.is-in-cart), aucun ajout. L'état suit le panier : lu à l'ouverture,
     au retour sur l'onglet et au retour arrière, pris dans
     'floorever:cart:change' ; un échantillon retiré au tiroir rend le
     bouton. Module panier commun (assets/floorever-cart.js) si présent.
     ------------------------------------------------------------------ */

  /* Lecture de /cart.js : module commun, sinon fetch direct. */
  function lirePanier(routePanier) {
    if (window.FloorEverCart) return window.FloorEverCart.lire(routePanier);
    return fetch(routePanier, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* Échantillons du panier, lignes gratuites : quantité totale, ids de
     variantes et réf. décor, par le module commun. Repli sans lui, ou
     avec une version qui ne lit pas les réf. : quantité et ids seuls. */
  function gratuits(panier) {
    var FC = window.FloorEverCart;
    if (FC && FC.gratuits) {
      var g = FC.gratuits(panier);
      return { total: g.total, ids: g.ids, refs: g.refs || [] };
    }
    var repli = { total: 0, ids: [], refs: [] };
    ((panier && panier.items) || []).forEach(function (item) {
      if (item.final_price === 0 || item.price === 0) {
        repli.total += item.quantity;
        repli.ids.push(item.variant_id);
      }
    });
    return repli;
  }

  /* Réf. décor d'un SKU d'échantillon, FEGP55308-ECH -> FE308, par le
     module commun ; chaîne vide sans lui. */
  function refDuSku(sku) {
    var FC = window.FloorEverCart;
    return FC && FC.refDecor ? FC.refDecor(sku, '') : '';
  }

  function initEchantillon(root, routeAjout, routePanier, maxEchantillons) {
    var btn = root.querySelector('[data-pdp-sample]');
    if (!btn) return;

    var labelEl = btn.querySelector('[data-pdp-sample-label]');
    var statut = root.querySelector('[data-pdp-sample-status]');
    var variantId = parseInt(btn.dataset.variantId, 10);
    var ref = (btn.dataset.ref || '').toUpperCase() || refDuSku(btn.dataset.sku);
    var labelBase = labelEl ? labelEl.textContent : '';
    var enCours = false;
    var ajoute = false;      /* « Ajouté » à l'écran, 3 s */
    var dedansApres = true;  /* état à rendre à la fin de « Ajouté » */
    if (!variantId) return;

    function message(txt) {
      if (!statut) return;
      statut.textContent = txt || '';
      statut.hidden = !txt;
    }

    /* Décor déjà au panier : même variante, ou même réf. FExxx venue
       d'une autre gamme. */
    function dejaAuPanier(g) {
      return g.ids.indexOf(variantId) !== -1 || (ref !== '' && g.refs.indexOf(ref) !== -1);
    }

    /* Échantillon du décor au panier : bouton désactivé. La barre d'achat
       mobile (floorever-pdp-barre.js) recopie l'état. */
    function marquerDeja() {
      btn.disabled = true;
      btn.classList.remove('is-added');
      btn.classList.add('is-in-cart');
      if (labelEl) labelEl.textContent = btn.dataset.labelIncart || 'Déjà dans le panier';
    }

    /* Échantillon retiré du panier, au tiroir, à la page panier ou dans
       un autre onglet : le bouton redevient disponible. */
    function liberer() {
      btn.disabled = false;
      btn.classList.remove('is-added', 'is-in-cart');
      if (labelEl) labelEl.textContent = labelBase;
    }

    /* Aligne le bouton sur un panier lu ou reçu par événement. Pendant
       « Ajouté », l'état est retenu pour la fin du retour visuel ;
       pendant un clic, c'est le clic qui décide. */
    function synchroniser(panier) {
      if (!panier || !panier.items) return;
      var dedans = dejaAuPanier(gratuits(panier));
      if (ajoute) { dedansApres = dedans; return; }
      if (enCours) return;
      if (dedans) marquerDeja();
      else liberer();
    }

    function relire() {
      lirePanier(routePanier).then(synchroniser).catch(function () {
        /* dégradé : le clic relit le panier */
      });
    }

    btn.addEventListener('click', function () {
      if (enCours || btn.disabled) return;
      enCours = true;
      btn.setAttribute('aria-busy', 'true');
      message('');

      /* Quota et décor relus à chaque clic : ils ont pu changer ailleurs. */
      lirePanier(routePanier)
        .then(function (panier) {
          var g = gratuits(panier);
          if (dejaAuPanier(g)) {
            marquerDeja();
            var deja = new Error('deja');
            deja.gere = true;
            throw deja;
          }
          if (g.total >= maxEchantillons) {
            message(statut ? statut.dataset.msgLimit : '');
            var stop = new Error('limite');
            stop.gere = true;
            throw stop;
          }
          return fetch(routeAjout, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('ajout impossible (' + r.status + ')');
          return r.json();
        })
        .then(function () {
          ajoute = true;
          dedansApres = true;
          if (labelEl) labelEl.textContent = btn.dataset.labelSuccess || 'Ajouté';
          btn.classList.add('is-added');
          majCompteurPanier(routePanier);
          window.setTimeout(function () {
            ajoute = false;
            if (dedansApres) marquerDeja();
            else liberer();
          }, 3000);
        })
        .catch(function (err) {
          if (!err || !err.gere) message(statut ? statut.dataset.msgError : '');
        })
        .finally(function () {
          enCours = false;
          btn.removeAttribute('aria-busy');
        });
    });

    /* Mutation venue d'une autre surface : le panier de l'événement
       suffit. Retour sur l'onglet, retour arrière : relecture. */
    document.addEventListener('floorever:cart:change', function (e) {
      synchroniser(e.detail ? e.detail.cart : null);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') relire();
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) relire();
    });
    relire();
  }

  /* Met à jour la pastille du header (.cart-link .cart-count) et notifie
     le reste du thème. */
  function majCompteurPanier(routePanier) {
    /* Module commun (assets/floorever-cart.js) : pastille + événement, source normalisée. */
    if (window.FloorEverCart) return window.FloorEverCart.rafraichir(routePanier, 'fiche');
    fetch(routePanier, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var lien = document.querySelector('.cart-link');
        if (lien) {
          var compteur = lien.querySelector('.cart-count');
          if (!compteur && panier.item_count > 0) {
            compteur = document.createElement('span');
            compteur.className = 'cart-count';
            compteur.setAttribute('aria-hidden', 'true');
            lien.appendChild(compteur);
          }
          if (compteur) compteur.textContent = panier.item_count;
          lien.setAttribute(
            'aria-label',
            'Panier, ' + panier.item_count + ' article' + (panier.item_count > 1 ? 's' : '')
          );
        }
        document.dispatchEvent(
          new CustomEvent('floorever:cart:change', { detail: { cart: panier, source: 'fiche' } })
        );
      })
      .catch(function () { /* silencieux : la pastille sera juste obsolète */ });
  }

  /* ------------------------------------------------------------------
     Bootstrap (multi-instances + éditeur de thème)
     ------------------------------------------------------------------ */
  function initPdp(root) {
    if (root.dataset.pdpInit === 'true') return;
    root.dataset.pdpInit = 'true';

    var prixColis = (parseInt(root.dataset.prixColisCents, 10) || 0) / 100;
    var m2Colis = parseFloat(root.dataset.m2Colis) || 0;
    var estSol = root.dataset.estSol === 'true';
    var minColis = parseInt(root.dataset.minColis, 10) || 0;
    var maxEchantillons = parseInt(root.dataset.maxEchantillons, 10) || 3;
    var routeAjout = (root.dataset.routeCartAdd || '/cart/add') + '.js';
    var routePanier = (root.dataset.routeCart || '/cart') + '.js';

    initGalerie(root);
    var achat = initAchat(root, prixColis, m2Colis, estSol, minColis);
    initDecors(root, achat);
    initEchantillon(root, routeAjout, routePanier, maxEchantillons);
    initComparer(root);
  }

  /* Comparatif contextuel replié : à l'ouverture, révèle la colonne de
     la gamme courante — souvent hors écran sur MOBILE quand le décor
     existe en 3-4 gammes (la colonne critères sticky couvre ~110 px).
     Sans JS : <details> natif, scroll manuel — rien de cassé. */
  function initComparer(root) {
    var comparer = root.querySelector('.pdp-comparer');
    if (!comparer) return;
    comparer.addEventListener('toggle', function () {
      if (!comparer.open) return;
      var scroll = comparer.querySelector('.cg-scroll');
      var actif = comparer.querySelector('thead th.is-active');
      if (!scroll || !actif) return;
      var critere = comparer.querySelector('thead .cg-critere');
      var wCritere = critere ? critere.offsetWidth : 0;
      var zone = scroll.clientWidth - wCritere; /* fenêtre utile à droite du sticky */
      /* Colonne déjà entièrement visible à droite du sticky : on ne
         bouge pas, sinon la première gamme passe sous les critères. */
      var gauche = actif.offsetLeft - scroll.scrollLeft;
      if (gauche >= wCritere && gauche + actif.offsetWidth <= scroll.clientWidth) return;
      var cible = actif.offsetLeft - wCritere - (zone - actif.offsetWidth) / 2;
      scroll.scrollLeft = Math.max(0, cible);
    });
  }

  function initTout(scope) {
    (scope || document).querySelectorAll('[data-pdp]').forEach(initPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTout(); });
  } else {
    initTout();
  }

  /* Rechargement de section dans l'éditeur de thème. */
  document.addEventListener('shopify:section:load', function (e) {
    initTout(e.target);
  });
})();
